import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-warehouseload',
    templateUrl: './warehouseload.html',
    styleUrls: ['./warehouseload.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarehouseloadComponent implements OnInit {
  percentageValue: number;
  classPercentage: string = 'layer-';

  constructor() { }

  ngOnInit(): void {
  }
  @Input() public set percentage(val: any) {
    if (val != undefined && val.length != 0) {
      this.percentageValue = val;
      
      if(val <= 50){
        this.classPercentage += 50;
      } else if(val >= 51 && val <= 75){
        this.classPercentage += 51;
      } else {
        this.classPercentage += 76;
      }
    }
  }
}
